import React from "react";
import { useTranslation } from "react-i18next";
import { EditMenuLink, MenuLink } from "../../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../../UI/Modal";
import MenuLinkForm from "../MenuLinkForm";

type Props = {
  menuLink?: MenuLink;
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  onSubmit: (data: EditMenuLink) => void;
};

const MenuLinkModal: React.FC<Props> = ({
  menuLink,
  isOpen,
  isSubmitting,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {!menuLink
            ? t("components.common.menuLinkModal.typeNew")
            : t("components.common.menuLinkModal.typeEdit")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <MenuLinkForm
          isSubmitting={isSubmitting}
          onSubmit={(data: any) => onSubmit(data)}
          onCancel={onClose}
          menuLink={menuLink}
        />
      </ModalBody>
    </Modal>
  );
};

export default MenuLinkModal;
